import { ServerClient } from 'common/utils/http/http-clients';
import { IResponseList } from 'common/models/response-list.interface';
import { IAddEditVisitorBanListEntry, ICheckRequest, ICheckResult, IVisitorBanListEntry } from './visitor-ban-list.service.types.';

class VisitorBanListService {
  async getVisitorBanList(
    pageLimit: any,
    filter: string | null | undefined,
    sort: string | null | undefined,
    search: string | null | undefined = '',
  ): Promise<IResponseList<IVisitorBanListEntry>> {
    const res = await ServerClient.get<IResponseList<IVisitorBanListEntry>>('visitor-ban-list', {
      params: {
        filter,
        ...pageLimit,
        sort,
        search,
      },
    });
    return res?.data;
  }

  async create(model: IAddEditVisitorBanListEntry): Promise<IVisitorBanListEntry> {
    const res = await ServerClient.post('visitor-ban-list', model);
    return res.data;
  }

  async update(id: string, model: IAddEditVisitorBanListEntry): Promise<IVisitorBanListEntry> {
    const res = await ServerClient.put(`visitor-ban-list/${id}`, model);
    return res.data;
  }

  async delete(id: string): Promise<IVisitorBanListEntry> {
    const res = await ServerClient.delete(`visitor-ban-list/${id}`);
    return res.data;
  }

  async check(model: ICheckRequest): Promise<ICheckResult> {
    const res = await ServerClient.post(`visitor-ban-list/check`, model);
    return res.data;
  }
}

export const visitorBanListService = new VisitorBanListService();
export default visitorBanListService;
